module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.showFilter) ? _c('div', {
    staticClass: "wrap"
  }, [_c('div', {
    staticClass: "container no-padding"
  }, [(!_vm.startView) ? _c('div', {
    class: {
      column: true
    }
  }, [_c('div', {
    staticClass: "center filter-skischool"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('general.pick-startdate')))]), _vm._v(" "), _c('Dropdown', {
    ref: "dateDropdown",
    attrs: {
      "prefixicon": "calendar",
      "prefixicon-validated": "calendar-white",
      "tabindex": "0",
      "options": [],
      "label": _vm.$store.state.skiSchoolFilter.date ? (_vm.moment(_vm.$store.state.skiSchoolFilter.date).format('D MMMM')) : _vm.$t('general.pick-startdate'),
      "bold-label": false,
      "validated": _vm.$store.state.skiSchoolFilter.date
    },
    on: {
      "clicked": _vm.openDateModal,
      "clicked-suffix": _vm.dateClear
    }
  }), _vm._v(" "), (_vm.SITE_CONFIG.translations.texts['texts-skischool-notice-about-days-' + _vm.$route.query.type]) ? _c('div', {
    staticStyle: {
      "max-width": "200px",
      "text-align": "left",
      "font-weight": "300",
      "opacity": "0.8",
      "font-size": "0.875rem"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('texts.texts-skischool-notice-about-days-' + _vm.$route.query.type)))])]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (!_vm.startView) ? _c('div', {
    class: {
      column: true, disabled: false
    }
  }, [_c('div', {
    staticClass: "center"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('skischool.pick-type')))]), _vm._v(" "), _vm._l((_vm.types), function(option) {
    return _c('div', {
      class: {
        button: true,
          underlined: true,
          'small-text': true,
          checked: (_vm.$route.query.type === option.key),
      },
      on: {
        "click": function($event) {
          return _vm.changeType(option.key)
        }
      }
    }, [_vm._v("\n            " + _vm._s(option.title) + "\n          ")])
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.startView && _vm.$route.query.type !== 'snowboard') ? _c('div', {
    staticClass: "column age-filter"
  }, [_c('div', {
    staticClass: "center"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Välj startdatum")]), _vm._v(" "), _c('Dropdown', {
    ref: "dateDropdown",
    attrs: {
      "prefixicon": "calendar",
      "prefixicon-validated": "calendar-white",
      "tabindex": "0",
      "options": [],
      "label": _vm.$store.state.skiSchoolFilter.date ? (_vm.moment(_vm.$store.state.skiSchoolFilter.date).format('D MMMM')) : 'Välj startdatum',
      "bold-label": false,
      "validated": _vm.$store.state.skiSchoolFilter.date
    },
    on: {
      "clicked": _vm.openDateModal,
      "clicked-suffix": _vm.dateClear
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.options.length) ? _c('div', {
    class: {
      column: true, disabled: !(_vm.$route.query.type !== 'private' && _vm.$route.query.type !== 'snowboard')
    }
  }, [_c('div', {
    staticClass: "center"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('skischool.pick-age')))]), _vm._v(" "), _vm._l((_vm.options), function(option) {
    return _c('div', {
      class: {
        button: true,
          underlined: true,
          'small-text': true,
          checked: (_vm.$store.state.skiSchoolFilter[option.key]),
      },
      on: {
        "click": function($event) {
          return _vm.toggleFilter(option.key)
        }
      }
    }, [_vm._v("\n            " + _vm._s(option.title) + "\n          ")])
  })], 2)]) : _vm._e(), _vm._v(" "), (!_vm.startView && (_vm.SITE_CONFIG.site !== 'vallasen' || _vm.$route.query.type !== 'private') && _vm.levels.length) ? _c('div', {
    class: {
      column: true, disabled: !(_vm.showlevels && _vm.$route.query.type !== 'snowboard')
    }
  }, [_c('div', {
    staticClass: "center margin-filter"
  }, [_c('div', [(_vm.SITE_CONFIG.site === 'branas' || _vm.SITE_CONFIG.site === 'kungsberget') ? _c('div', {
    staticClass: "label level-label"
  }, [_vm._v(_vm._s(_vm.$t('skischool.pick-level')))]) : _c('div', {
    staticClass: "label level-label"
  }, [_vm._v(_vm._s(_vm.$t('skischool.pick-level-2')))]), _vm._v(" "), _vm._l((_vm.levels), function(level) {
    return _c('button', {
      class: {
        'level-filter': true,
        checked: (_vm.$store.state.skiSchoolFilter[level.key]),
          disabled: (
            (_vm.$route.query.type === 'private' && _vm.SITE_CONFIG.site === 'branas') ||
            (!(_vm.showLevel(level.key).indexOf(_vm.currentAge) !== -1) && _vm.$route.query.type !== 'private')
          )
      },
      on: {
        "click": function($event) {
          return _vm.toggleFilter(level.key)
        }
      }
    }, [_c('icon', {
      attrs: {
        "name": level.key + '-circle',
        "scale": 1.8
      }
    }), _vm._v(_vm._s(level.title))], 1)
  })], 2)])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "container"
  })]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-07865c16"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/SkiSchool/SkiSchoolFilter.vue
// module id = 905
// module chunks = 0